import { ComponentFactoryResolver, NgModule } from '@angular/core';
import { moduleConfigFunc, TnxSharedModule } from 'tnx-shared';
import { AddressFormComponent } from './address-form/address-form.component';
import { AddressComponent } from './address.component';
import { AddressRoutes } from './address.routing';
import { BaseModule } from 'tnx-shared';

export function declaration() {
    return [AddressComponent, AddressFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration(),
    entryComponents: [AddressComponent]
})
export class AddressModule extends BaseModule {
    dynamicComponents = [AddressComponent];

    static forRoot(config?: any): any {
        return {
            ngModule: TnxSharedModule,
            providers: [
                {
                    provide: moduleConfigFunc,
                    useValue: config
                }
            ]
        };
    }

    constructor(componentFactoryResolver: ComponentFactoryResolver) {
        super(componentFactoryResolver);
    }
}

@NgModule({
    imports: [AddressModule, AddressRoutes],
    exports: [AddressModule]
})
export class AddressWithRouteModule {
    static forRoot(config?: any): any {
        return {
            ngModule: TnxSharedModule,
            providers: [
                {
                    provide: moduleConfigFunc,
                    useValue: config
                }
            ]
        };
    }
}
